import { useState, useEffect } from 'react';
import { isEqual } from 'lodash';

import Append from '../../components/renconcilationtype/Append';
import { isValidConfig, buildConfig } from './utils';

const AppendContainer = ({ configData, saveData, setError }) => {
    const [updatedConfigData, setUpdatedConfigData] = useState([]);

    /* callback function called when updatedConfigData is changed */
    const onAppendSaveConfig = () => {
        if (updatedConfigData.length > 0) {
            const config = buildConfig(updatedConfigData, 'Append');
            // function to save the recon configuration
            saveData({
                flow: {
                    ...config,
                },
            });
        }
    };

    /* map selected columns where isConcateCheck is set */
    const concateData = updatedConfigData.map(uc => ({
        ...uc,
        selectedColumns: uc.selectedColumns.filter(data => data.isConcateCheck),
    }));

    /* side effect when config data is changed */
    useEffect(() => {
        const { message } = isValidConfig(configData);
        if (message !== '') {
            setError({ message });
        }
        if (!isEqual(updatedConfigData, configData)) {
            setUpdatedConfigData(configData);
        }
    }, [configData]);

    /* side effect when updatedConfigData is changed */
    useEffect(() => {
        if (updatedConfigData.length > 0) {
            onAppendSaveConfig();
        }
    }, [updatedConfigData]);

    /* callback function called when Append config is changed */
    const onHandleChange = event => {
        const { target: { name, checked, id } } = event;
        setUpdatedConfigData(prevState => {
            let data = [...prevState];
            data = data.map(item => {
                if (item.id === id) {
                    return {
                        ...item,
                        selectedColumns: item.selectedColumns.map(sc => (sc.column === name ? { ...sc, isConcateCheck: checked } : sc)),
                    };
                }
                return item;
            });
            return data;
        });
    };

    return (
        <Append
            concateData={concateData}
            onHandleChange={onHandleChange}
            updatedConfigData={updatedConfigData}
        />
    );
};

export default AppendContainer;
